import Modal from './Modal.jsx';

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx